export default __webpack_public_path__ + "static/media/hamburger.f83298c0.svg";